const statuses = {
  ACCEPTED: 'ACCEPTED',
  BOOKED: 'BOOKED',
  SAVED: 'SAVED',
};

export default statuses;
